import { combineReducers } from 'redux';
import scoring from './scoring.reducer';
import endeavorReducer from './endeavor.reducer';
import articlesReducer from './articles.reducer';

const appReducers = combineReducers({
    scoring,
    endeavorReducer,
    articlesReducer,
});

export default appReducers;
